import React from 'react';
import { Link } from "react-router-dom"

const Error = () => {
    return <div>
        <h1>404</h1>
        <p>Stránka nenalezena</p>
        <p><Link to="/">zpět na úvod</Link></p>
    </div>

}

export default Error;